<template>
	<DiscoveryTableSingleAdd/>
</template>

<script>
import DiscoveryTableSingleAdd from "@/components/DiscoveryTable/DiscoveryTableSingle/DiscoveryTableSingleAdd";

export default {
	name: "DiscoveryPageSingleAdd",
	components: {
		DiscoveryTableSingleAdd
	}
}
</script>

<style scoped>

</style>